import React, { createContext, useContext, useState } from 'react';
import { Snackbar, Alert } from 'components/ui';
import { FormattedMessage } from 'react-intl';
const ErrorContext = createContext();

export const ErrorProvider = ({ children }) => {
  const [error, setError] = useState(null);

  return (
    <ErrorContext.Provider value={setError}>
      {error && (
        <Snackbar open={!!error} autoHideDuration={6000} onClose={() => setError(null)}>
          <Alert onClose={() => setError(null)} severity="error">
            <FormattedMessage id={error} />
          </Alert>
        </Snackbar>
      )}
      {children}
    </ErrorContext.Provider>
  );
};

export const useError = () => useContext(ErrorContext);
